import React, { Fragment } from 'react';
import { showNotification } from './../../../utils';
import SelectField from './../Form/SelectField';
import numeral from 'numeral';

const Form = React.memo((props) => {
    if (props.staticTemplate == null) {
        return null;
    }

    const continueHandler = (type = 1) => {
        if (props.quantity === '') {
            return showNotification('Complete Information', 'Select a quantity', 'info');
        }
        if (parseInt(props.templateCode) !== 647 && props.staticTemplate.use_printing_option && props.printingOption === '') {
            return showNotification('Complete Information', 'Select a printing option', 'info');
        }
        if (parseInt(props.templateCode) === 473) {
            if (props.language === '') {
                return showNotification('Complete Information', 'Select a Language', 'info');
            }
            if (props.orientation === '') {
                return showNotification('Complete Information', 'Select an Orientation', 'info');
            }
            if (props.materialType === '') {
                return showNotification('Complete Information', 'Select a Material Type', 'info');
            }
            if (props.size === '') {
                return showNotification('Complete Information', 'Select a Size', 'info');
            }
        } else if (parseInt(props.templateCode) === 647) {
            if (props.language === '') {
                return showNotification('Complete Information', 'Select a Language', 'info');
            }
            if (props.type === '') {
                return showNotification('Complete Information', 'Select a Type', 'info');
            }
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, type);
        } else {
            props.addToCart(2, props.history, type);
        }
    };

    const quantityOptions = [{ value: '', label: 'Select option' }];
    if (parseInt(props.templateCode) === 473) {
        for (let i = 1; i <= 10; i++) {
            quantityOptions.push({
                value: i,
                label: i,
            });
        }
    } else if (parseInt(props.templateCode) === 647) {
        for (let i = 1; i <= 10; i++) {
            quantityOptions.push({
                value: i,
                label: i,
            });
        }
    } else if (parseInt(props.templateCode) === 640) {
        for (let i = 1; i <= 4; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    } else if (parseInt(props.templateCode) === 644) {
        for (let i = 1; i <= 4; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    } else if (parseInt(props.templateCode) === 645) {
        quantityOptions.push({ value: 100, label: '100 pieces' });
        quantityOptions.push({ value: 250, label: '250 pieces' });
        quantityOptions.push({ value: 500, label: '500 pieces' });
        quantityOptions.push({ value: 1000, label: '1000 pieces' });
    } else if (parseInt(props.templateCode) === 647) {
        for (let i = 1; i <= 25; i++) {
            quantityOptions.push({
                value: i,
                label: i,
            });
        }
    } else if (parseInt(props.templateCode) === 648) {
        for (let i = 1; i <= 9; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    } else if (parseInt(props.templateCode) === 649) {
        for (let i = 1; i <= 4; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    } else if (parseInt(props.templateCode) === 650) {
        for (let i = 1; i <= 5; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    } else if (parseInt(props.templateCode) === 651) {
        for (let i = 1; i <= 4; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    } else if (parseInt(props.templateCode) === 652) {
        quantityOptions.push({ value: 100, label: '100 pieces' });
        quantityOptions.push({ value: 250, label: '250 pieces' });
        quantityOptions.push({ value: 500, label: '500 pieces' });
        quantityOptions.push({ value: 500, label: '500 pieces' });
        quantityOptions.push({ value: 1000, label: '1,000 pieces' });
    } else {
        for (let i = 1; i <= 10; i++) {
            quantityOptions.push({
                value: i,
                label: i + (i > 1 ? ' bundles' : ' bundle') + ' ('
                    + numeral(props.staticTemplate.pieces_per * i).format('0,0') + ' pieces)'
            });
        }
    }

    let description1 = null;
    if (props.staticTemplate.description1) {
        description1 = <li>{props.staticTemplate.description1}</li>;
    }

    let description2 = null;
    if (props.staticTemplate.description2) {
        description2 = <li>{props.staticTemplate.description2}</li>;
    }

    let description3 = null;
    if (props.staticTemplate.description3) {
        description3 = <li>{props.staticTemplate.description3}</li>;
    }

    let description4 = null;
    if (props.staticTemplate.description4) {
        description4 = <li>{props.staticTemplate.description4}</li>;
    }

    let description5 = null;
    if (props.staticTemplate.description5) {
        description5 = <li>{props.staticTemplate.description5}</li>;
    }

    let description6 = null;
    if (props.staticTemplate.description6) {
        description6 = <li>{props.staticTemplate.description6}</li>;
    }

    let description7 = null;
    if (props.staticTemplate.description7) {
        description7 = <li>{props.staticTemplate.description7}</li>;
    }

    let description8 = null;
    if (props.staticTemplate.description8) {
        description8 = <li>{props.staticTemplate.description8}</li>;
    }

    let description9 = null;
    if (props.staticTemplate.description9) {
        description9 = <li>{props.staticTemplate.description9}</li>;
    }

    let description10 = null;
    if (props.staticTemplate.description10) {
        description10 = <li>{props.staticTemplate.description10}</li>;
    }

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    let printingOptionField = null;
    if (props.staticTemplate.use_printing_option) {
        printingOptionField = (
            <SelectField
                required
                label="Printing Option"
                value={props.printingOption}
                setFunction={props.setPrintingOption}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'bw', label: 'Black & White' },
                    { value: 'color', label: 'Color' },
                ]}
            />
        );
    }
    if (parseInt(props.templateCode) === 644) {
        printingOptionField = (
            <SelectField
                required
                label="Printing Option"
                value={props.printingOption}
                setFunction={props.setPrintingOption}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'color', label: 'Color' },
                ]}
            />
        );
    }

    let languageField = null;
    let orientationField = null;
    let materialTypeField = null;
    let sizeField = null;
    let description = null;
    let typeField = null;
    let paperField = null;
    if (parseInt(props.templateCode) === 473) {
        languageField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
        );
        orientationField = (
            <SelectField
                required
                label="Orientation"
                value={props.orientation}
                setFunction={props.setOrientation}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'Portrait', label: 'Portrait' },
                    { value: 'Landscape', label: 'Landscape' },
                ]}
            />
        );
        materialTypeField = (
            <SelectField
                required
                label="Material Type"
                value={props.materialType}
                setFunction={props.setMaterialType}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'Form Board', label: 'Form Board' },
                    { value: 'Lamination', label: 'Lamination' },
                ]}
            />
        );

        let sizeOptions = [
            { value: '', label: 'Select Option' },
            { value: '24" x 36"', label: '24" x 36"' },
        ];
        if (props.orientation === 'Landscape') {
            sizeOptions = [
                { value: '', label: 'Select Option' },
                { value: '24" x 36"', label: '24" x 36"' },
                { value: '24" x 18"', label: '24" x 18"' },
                { value: '18" x 18"', label: '18" x 18"' },
            ];
        }

        sizeField = (
            <SelectField
                required
                label="Size"
                value={props.size}
                setFunction={props.setSize}
                options={sizeOptions}
            />
        );

        description = (
            <div className="poster-description">
                <p>
                    Infection Prevention is combining some of the required
                    COVID-19 messaging into one sign that can be displayed
                    near the entrance lobby (foam board) or applied to the
                    door facing the entrance (laminated poster or vinyl cling).
                </p>
                <p>
                    It will be up to each practice manager to determine what
                    type of signage and size works best for their respective
                    clinic, based on where the signage will be displayed. To
                    provide added flexibility, there are multiple sizes and
                    layouts that you can choose from.
                </p>
                <p>
                    <b>Sizes:</b> Portrait (24" Tall x 36" Wide) and Landscape (36" x 24" | 24" x 18" | 18" x 18")
                </p>
                <p><b>Materials:</b></p>
                <p>
                    <div>Foam Board (easel not included).</div>
                    <div>Is a rigid foam material (.25" thick).</div>
                    <div>Can easily be put on an easel or pin to a wall.</div>
                    <div>Is prone to damage if something hard hit up against it.</div>
                </p>
                <hr />
                <p>
                    <div>Laminated poster.</div>
                    <div>Print on photo paper.</div>
                    <div>Laminated both sides.</div>
                    <div>Easily rolled up and transport.</div>
                    <div>Easily affix to wall, window with double sided tape.</div>
                    <div>Minimum durability from water, abrasion and tear.</div>
                </p>
            </div>
        );
    } else if (parseInt(props.templateCode) === 647) {
        printingOptionField = null;

        typeField = (
            <SelectField
                required
                label="Type"
                value={props.type}
                setFunction={props.setType}
                options={[
                    { value: 'Framed Poster', label: 'Framed Poster' },
                    { value: 'Static Cling Poster', label: 'Static Cling Poster' },
                ]}
            />
        );

        languageField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
        );

        if (props.type === 'Framed Poster') {
            description = (
                <div className="poster-description">
                    <div><b>Detail:</b></div>
                    <ul>
                        <li>Patient Code of Conduct.</li>
                        <li>Size: 8.5" wide x 11" tall.</li>
                        <li>Full Color.</li>
                        <li>Include black parameter polyester frame.</li>
                        <li>Include wall-mount hooks to hang on the lobby wall.</li>
                    </ul>
                    <p>
                        This framed poster should be displayed near other required signage in the lobby.
                    </p>
                    <p>
                        It is also available as a static cling option for the back of exam room doors only.
                    </p>
                    <p>Select “Static Cling Poster” under the “Type” drop down to order separately.</p>
                </div>
            );
        } else if (props.type === 'Static Cling Poster') {
            description = (
                <div className="poster-description">
                    <div><b>Detail:</b></div>
                    <ul>
                        <li>Patient Code of Conduct.</li>
                        <li>Size: 8.5" wide x 11" tall.</li>
                        <li>Full Color.</li>
                        <li>Static cling wall mount poster for back of exam room doors.</li>
                        <li>Peel and stick to flat (Clean) surface.</li>
                    </ul>
                    <p>
                        This static cling poster should be displayed on the back of exam room doors only.
                        No screws or holes are permitted on exam room doors
                    </p>
                    <p>
                        It is also available as a framed poster, and should be displayed near other
                        required signage in the lobby. Select “Framed Poster” under the “Type” drop
                        down to order separately
                    </p>
                </div>
            );
        }
    } else if (parseInt(props.templateCode) === 648) {
        languageField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
        );

        description = (
            <div className="description-list">
                <span className="label">Description:</span>
                <ul>
                    {description1}
                    {description2}
                    {description3}
                    {description4}
                    {description5}
                    {description6}
                    {description7}
                    {description8}
                    {description9}
                    {description10}
                </ul>
            </div>
        );
    } else if (parseInt(props.templateCode) === 649) {
        languageField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
        );

        description = (
            <div className="description-list">
                <div><span className="label">Description:</span></div>
                <div>
                    This card can be given to patients/parents by a health care professional to recommend the type of antibiotic and dose for IE prophylaxis.
                    The card is scored so it can be easily folded. Available in English or Spanish.
                </div>
                <div className="mt-2 mb-3">
                    <i>Source: American Heart Association</i>
                </div>
                <span className="label">Specs:</span>
                <ul>
                    {description1}
                    {description2}
                    {description3}
                    {description4}
                    {description5}
                    {description6}
                    {description7}
                    {description8}
                    {description9}
                    {description10}
                </ul>
            </div>
        );
    } else {
        description = (
            <div className="description-list">
                <span className="label">Description:</span>
                <ul>
                    {description1}
                    {description2}
                    {description3}
                    {description4}
                    {description5}
                    {description6}
                    {description7}
                    {description8}
                    {description9}
                    {description10}
                </ul>
            </div>
        );
    }

    let favoriteClasses = ['favorite-container'];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push('active');
        favoriteIcon = <i className="fas fa-heart filled-heart" />
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let shoppingCartButton = <button type="button" className="continue" onClick={continueHandler.bind(this, 1)} disabled={props.addingToCart}>{buttonLabel}</button>;
    if (props.action === 'edit') {
        shoppingCartButton = null;
    }

    let customDescription = null;
    let descriptionTitle = 'Description';
    if (parseInt(props.templateCode) === 645) {
        descriptionTitle = 'Details';
        customDescription = (
            <div className="description-section mt-3">
                <span className="label">Description:</span> UTHealth Houston and UT Physicians provide
                professional translation services for clear communications with patients. This document
                is available for clinics and other university patient care sites to offer to patients
                at check-in
            </div>
        );
    }

    if (parseInt(props.templateCode) === 650) {
        printingOptionField = null;
        descriptionTitle = 'Details';
        customDescription = (
            <div className="description-section mt-3">
                <span className="label">Description:</span> This handout card can be provided to pediatric 
                patients and their families to provide them the follow-up instructions after surgery. The 
                care team should circle the provider the patient is seeing.
            </div>
        );
        description = (
            <div className="description-list">
                <span className="label">Specs:</span>
                <ul>
                    {description1}
                    {description2}
                    {description3}
                    {description4}
                    {description5}
                    {description6}
                    {description7}
                    {description8}
                    {description9}
                    {description10}
                </ul>
            </div>
        );
    }
    
    if (parseInt(props.templateCode) === 651) {
        let sidedItem = <li>4/0 with bleed</li>;
        if (props.type === 'Did Not Pass') {
            sidedItem = <li>4/4 with bleed</li>;
        }

        printingOptionField = null;
        descriptionTitle = 'Details';
        customDescription = (
            <div className="description-section mt-3">
                <span className="label">Description:</span> Available in English and Spanish, these Newborn Hearing Screening 
                Results flyers can be provided to the patient depending on a Pass or Fail result. Select the language and the 
                result option in the drop-down to add each flyer type to your cart as needed.
            </div>
        );
        description = (
            <div className="description-list">
                <span className="label">Specs:</span>
                <ul>
                    <li>8.5x11"</li>
                    <li>28# text paper</li>
                    {sidedItem}
                    <li>Printed in bundles of 500</li>
                </ul>
            </div>
        );

        typeField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
        );

        languageField = (
            <SelectField
                required
                label="Result"
                value={props.type}
                setFunction={props.setType}
                options={[
                    { value: 'Pass', label: 'Pass' },
                    { value: 'Did Not Pass', label: 'Did Not Pass' },
                ]}
            />
        );
    }

    if (parseInt(props.templateCode) === 652) {
        printingOptionField = null;
        descriptionTitle = 'Details';
        customDescription = (
            <div className="description-section mt-3">
                <span className="label">Description:</span> This flyer provides an overview of hearing aid solutions, benefits, and clinic locations.
            </div>
        );
    }

    return (
        <div className="form-container">
            <h5>Variables</h5>
            <div className={favoriteClasses.join(' ')} onClick={handleAddFavorite}>
                {favoriteIcon} Favorites
            </div>
            <form action="">
                <hr />
                {typeField}
                {languageField}
                {orientationField}
                {materialTypeField}
                {sizeField}
                {paperField}
                <SelectField
                    required
                    label="Quantity"
                    value={props.quantity}
                    setFunction={props.setQuantity}
                    options={quantityOptions}
                />
                {printingOptionField}
                <hr />
                <h5 className="description-header">{descriptionTitle}</h5>
                <div className="description-section">
                    <div><span className="label">Title:</span> {props.staticTemplate.name}</div>
                    {customDescription}
                    {description}
                </div>
            </form>
            <div className="text-center">
                <div>
                    <button type="button" className="save-work" onClick={continueHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                    {shoppingCartButton}
                </div>
            </div>
        </div>
    );
});

export default Form;
